module.exports = __webpack_public_path__ + "static/frühförderung-6efe2e0f3e0dc5ec5bb578a2362a9a4d.jpg";